import { WISHLIST_WIDGET_NAMES } from "@/constants/widget-names";
import { WishlistDrawerWidgetDefinition } from "@apps/wishlist/definitions";
import AnalyticsEventsCollectorInterface from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsCollectorInterface";
import { AnalyticsEventsFactory } from "@modules/analytics_events_collector/AnalyticsEventsCollector/AnalyticsEventsFactory";
import { DynamicImportManager } from "@modules/dynamic_import/DynamicImportManager";
import WidgetInjectedSdkEvent from "@modules/sdk/common_sdk/events/WidgetInjectedSdkEvent";
import { dispatchSdkEvent } from "@modules/sdk/helpers";
import AttributesObserver from "@ui-utils/AttributesObserver/AttributesObserver";
import MutationObserverInjector from "@ui-utils/Injector/MutationObserverInjector";

import { LoggerInterface } from "@interfaces/LoggerInterface";

class WishlistDrawerWidgetInjector {
    constructor(
        private readonly placeholderSelector: string,
        private readonly logger: LoggerInterface,
        private readonly eventsCollector: AnalyticsEventsCollectorInterface,
        private readonly analyticsEventsFactory: AnalyticsEventsFactory,
        private readonly dynamicImportManager: DynamicImportManager,
        private readonly moi: MutationObserverInjector,
        private readonly attributesObserver: AttributesObserver
    ) {}

    start(): void {
        this.logger?.debug(`${WishlistDrawerWidgetInjector.name}.start`, {
            placeholderSelector: this.placeholderSelector,
        });

        const targets$ = this.moi.register({
            targetSelector: this.placeholderSelector,
        });

        targets$.subscribe((placeholder) => {
            this.logger?.debug(
                `${WishlistDrawerWidgetInjector.name} found placeholder`,
                {
                    placeholder,
                }
            );

            void (async () => {
                const WishlistDrawerWidget =
                    await this.dynamicImportManager.importDefault(
                        WishlistDrawerWidgetDefinition,
                        true
                    );

                const widget = new WishlistDrawerWidget(
                    {
                        target: placeholder,
                        attributesObserver: this.attributesObserver,
                    },
                    this.logger
                );

                await widget.init();

                this.eventsCollector.pushEvent(
                    this.analyticsEventsFactory.createWidgetInjected(
                        WISHLIST_WIDGET_NAMES.WISHLIST_DRAWER_WIDGET
                    )
                );

                dispatchSdkEvent(
                    new WidgetInjectedSdkEvent(
                        WISHLIST_WIDGET_NAMES.WISHLIST_DRAWER_WIDGET
                    )
                );
            })();
        });
    }
}

export default WishlistDrawerWidgetInjector;
